module.exports = __webpack_public_path__ + "img/progress_083.fa4dcc0d.png";